jQuery(document).ready(function ($) {

    $(".mail-delete-post").on("click", function (e) {
        var messageID = $(this).attr('data-delete'),
            nonce = $(this).attr('data-nonce'),
            data = {
                'action': 'delete_message_post',
                'postID': messageID,
                'nonce': nonce
            };
        $.ajax({
            url: jointsajax.ajaxurl,
            data: data,
            type: 'POST',
            success: function (result) { }
        });
    });

    $(".portal-doc-link").on("click", function (e) {
        var docRow = $(this).closest('.portal-doc'),
            docID = $(this).attr('data-docid'),
            nonce = $(this).attr('data-nonce'),
            data = {
                'action': 'doc_downloaded',
                'postID': docID,
                'nonce': nonce
            };

        docRow.removeClass('unread').addClass('read secondary');

        $.ajax({
            url: jointsajax.ajaxurl,
            data: data,
            type: 'POST',
            success: function (result) { }
        });
    });

});
